import React, { useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  // develoment
  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState(
  //   "http://127.0.0.1:8000/storage",
  // );

  // production
  const [baseUrl, setBaseUrl] = useState(
    "https://adfurniturehouse.btsportfolio2026.com/backend/public/api",
  );
  const [baseUrlForFile, setBaseUrlForFile] = useState(
    "https://adfurniturehouse.btsportfolio2026.com/backend/public/storage",
  );

  const [loggedInCustomer, setLoggedInCustomer] = useState(() => {
    const customer = localStorage.getItem("loggedInCustomer");
    return customer ? JSON.parse(customer) : null;
  });

  const [loggedInAdmin, setLoggedInAdmin] = useState(() => {
    const admin = localStorage.getItem("loggedInAdmin");
    return admin ? JSON.parse(admin) : null;
  });

  const [authToken, setAuthToken] = useState(
    () => localStorage.getItem("authToken") || "",
  );
  const [selectedCategoryForProducts, setSelectedCategoryForProducts] =
    useState("");

  const [cartCount, setCartCount] = useState("");

  // ── NOTIFICATION COUNTS ──────────────────────────
  const [notificationCount, setNotificationCount] = useState(0); // customer
  const [adminNotificationCount, setAdminNotificationCount] = useState(0); // admin

  const fetchNotificationCount = async () => {
    try {
      const res = await fetch(`${baseUrl}/customer/notification/count`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      const data = await res.json();
      if (data.success) {
        setNotificationCount(data.count);
      }
    } catch (error) {
      console.log("Customer notification count fetch error:", error);
    }
  };

  const fetchAdminNotificationCount = async () => {
    try {
      const res = await fetch(`${baseUrl}/admin/notification/count`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });
      const data = await res.json();
      if (data.success) {
        setAdminNotificationCount(data.count);
      }
    } catch (error) {
      console.log("Admin notification count fetch error:", error);
    }
  };
  // ──────────────────────────────────────────────────

  const fullNameRegex = /^[A-Za-z0-9 ]{5,}$/;
  const emailRegex = /^[A-Za-z0-9]{5,}@[a-z0-9]{3,}\.[a-z0-9.]{2,}$/;
  const passwordRegex = /^[A-Za-z0-9@*#^?&]{8,}$/;
  const phoneNoRegex = /^[0-9]{4}-[0-9]{7}$/;

  const RegExpChecker = (type, input) => {
    switch (type) {
      case "fullName":
        if (!fullNameRegex.test(input))
          return {
            fullName:
              "Username must be at least 5 characters and contain only letters and numbers.",
          };
        return { fullName: "" };
      case "email":
        if (!emailRegex.test(input))
          return {
            email:
              "Please enter a valid email address. Email should contain at least 5 characters (e.g., example@gmail.com).",
          };
        return { email: "" };
      case "password":
        if (!passwordRegex.test(input))
          return {
            password:
              "Password must be at least 8 characters and may include letters, numbers and @*#^?&.",
          };
        return { password: "" };
      case "phone":
        if (!phoneNoRegex.test(input))
          return {
            phone: "Please enter a valid phone number (e.g., 0312-3456789).",
          };
        return { phone: "" };
      default:
        return {};
    }
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFile,
        loggedInCustomer,
        loggedInAdmin,
        selectedCategoryForProducts,
        authToken,
        cartCount,
        setCartCount,
        notificationCount,
        setNotificationCount,
        fetchNotificationCount,
        adminNotificationCount,
        setAdminNotificationCount,
        fetchAdminNotificationCount,
        setAuthToken,
        setBaseUrl,
        setBaseUrlForFile,
        setSelectedCategoryForProducts,
        setLoggedInCustomer,
        setLoggedInAdmin,
        RegExpChecker,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
